import axios from "axios";
import router from "src/main.js";

window.addEventListener(
  "storage",
  (event) => {
    const { storageArea, newValue, key } = event;
    if (storageArea === localStorage) {
      if (key === "token" && !newValue) {
        delete axios.defaults.headers.common["Authorization"];
      }
    }
  },
  false
);

async function loginSuccess(commit, dispatch, data) {
  commit("loginSuccess", data);
}

function storeUser(user) {
  localStorage.setItem("user", JSON.stringify(user));
}

function storeTokens(tokens) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + tokens.token;
  localStorage.setItem("token", tokens.token);
  localStorage.setItem("refreshToken", tokens.refreshToken);
}

function addLoginInfo(data = {}) {
  return {
    ...data,
  };
}

const state = {
  user: JSON.parse(localStorage.getItem("user")),
  loggedIn: false,
  token: null,
  refreshToken: null,
  isLoading: false,
  errorAuth: null,
};

const mutations = {
  setLoggedIn(state, value) {
    state.loggedIn = value;
  },
  setLoading(state, value) {
    state.isLoading = value;
  },
  setError(state, value) {
    state.errorAuth = value;
  },
  loginSuccess(state, data) {
    const { token, refreshToken, user } = data.data;
    // changeRefreshTokens(refreshToken);
    storeTokens({ token, refreshToken });
    state.user = user;
    storeUser(user);
    router.push("/user");
  },
  // Used to update tokens after using refresh token
  changeTokens(state, data) {
    storeTokens(data.token);
  },
  changeRefreshTokens(state, data) {
    setRefreshTokens(data.refreshToken);
  },
};

const actions = {
  async login({ commit, dispatch }, data) {
    try {
      commit("setLoading", true);
      let response = await axios.post(
        `${process.env.VUE_APP_API_ENDPOINT}auth/login`,
        addLoginInfo(data)
      );
      commit("setLoggedIn", true);
      loginSuccess(commit, dispatch, response.data);
    } catch (res) {
      if (res.response.data.errorCode === 107) {
        commit("setError", "Email or password is invalid");
      }
    } finally {
      commit("setLoading", false);
    }
  },
  async logout({ commit }) {
    state.isLoading = true;
    location.href = "/";
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("botData");
    localStorage.removeItem("botDataSelectedLinks");
    localStorage.removeItem("botDataLinks");
    localStorage.removeItem("chosenWidget");
    localStorage.removeItem("user");
    delete axios.defaults.headers.common["Authorization"];
    commit("setLoggedIn", false);
    state.isLoading = false;
  },
  
  async sendVerify({ commit, dispatch }, data) {
    try {
      commit("setLoading", true);
      axios
        .post(`${process.env.VUE_APP_API_ENDPOINT}users/verify`, data)
        .then((res) => {
          if (!res.data.data) return;
          commit("setLoggedIn", true);
          loginSuccess(commit, dispatch, res.data);
          commit("setLoading", false);
          gtag('event', 'registration_code_entered', {});
          amplitude.getInstance().logEvent('registration_code_entered', {});
        })
        .catch((error) => {
          console.log("Error!", error);
          commit("setLoading", false);
        });
    } catch (error) {}
  },
  setLoggedIn({ commit, dispatch }, data) {
    commit("setLoggedIn", data);
  },
};

const getters = {
  isLoggedIn: (state) => {
    return state.loggedIn;
  },
  isErrorAuth: (state) => {
    return state.errorAuth;
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
